import React from 'react';
import { ButtonContainer } from '../ButtonContainer/ButtonContainer';
import { PrimaryButton, SecondaryButton } from '@weareopenr/component-library';

type Props = {
  showCancelBtn: boolean;
  closeModal: () => void;
  decrementStep: () => void;
  showConfirmBtn: boolean;
  isSubmitting: boolean;
  continueDisabled: boolean;
  incrementStep: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

const PriceRuleContinueButtons = ({
  showCancelBtn,
  closeModal,
  decrementStep,
  showConfirmBtn,
  isSubmitting,
  continueDisabled,
  incrementStep,
}: Props) => {
  return (
    <ButtonContainer
      left={
        showCancelBtn ? (
          <SecondaryButton size="full-width" buttonStyle="outline" type="button" onClick={closeModal}>
            Cancel
          </SecondaryButton>
        ) : (
          <SecondaryButton size="full-width" buttonStyle="outline" type="button" onClick={decrementStep}>
            Back
          </SecondaryButton>
        )
      }
      right={
        showConfirmBtn ? (
          <PrimaryButton
            type="submit"
            size="full-width"
            disabled={isSubmitting || continueDisabled}
            loading={isSubmitting}
          >
            Save
          </PrimaryButton>
        ) : (
          <PrimaryButton size="full-width" type="button" onClick={incrementStep} disabled={continueDisabled}>
            Continue
          </PrimaryButton>
        )
      }
    />
  );
};

export default PriceRuleContinueButtons;
